export class PersonEvaluationSummary implements IPersonEvaluationSummary {
  public teamId: string;
  public teamName: string;
  public evaluateePosition: string;
  public evaluationFormId: string;
  public evaluationName: string;
  public lastEvaluationResponseDate: Date;
  public rating: number;

  static parse(data: IPersonEvaluationSummary): PersonEvaluationSummary {
    if (!data) return null;
    let evaluation = new PersonEvaluationSummary();
    Object.assign(evaluation, data);
    return evaluation;
  }
}

export interface IPersonEvaluationSummary {
  teamId: string;
  teamName: string;
  evaluateePosition: string;
  evaluationFormId: string;
  evaluationName: string;
  lastEvaluationResponseDate: Date;
  rating: number;
}
